import axios from 'axios';
import type { DateTime } from 'luxon';

export default class ArticleCategoriesService
{
    public static path = 'admin/cms/articles/categories';

    public static async getList(filter: FilterModel, pager: Pager)
    {
        return (await axios.get<Pagination<Resource<ListItemModel>>>(this.path, {
            params: { ...filter, ...pager.data() }
        })).data;
    }

    public static async fetch(id: number)
    {
        return (await axios.get<Resource<FormModel>>(`${this.path}/${id}`)).data;
    }

    public static async create(model: FormModel)
    {
        return (await axios.post<Resource<FormModel>>(this.path, model)).data;
    }

    public static async update(id: number, model: FormModel)
    {
        return (await axios.put<Statement>(`${this.path}/${id}`, model)).data;
    }

    public static async remove(id: number)
    {
        return (await axios.delete(`${this.path}/${id}`)).data as Statement;
    }

    public static async getAll()
    {
        return (await axios.get<Resource<ListItemModel[]>>(`${this.path}/all`)).data;
    }

    public static async getAllArticleCategoriesList()
    {
        return (await axios.get<Pagination<Resource<ListItemModel>>>(`${this.path}/sort`, {
            params: {}
        })).data;
    }

    public static async sortArticleCategories(positions: PositionModel[])
    {
        return (await axios.put<Statement>(`${this.path}/sort/positions`, positions)).data;
    }

    public static async getAutocomplete(search: string, limit: number = 10)
    {
        return (await axios.get<string[]>(`${this.path}/autocomplete/names`, {
            params: {
                search: search,
                limit: limit
            }
        })).data;
    }

    public static async fetchAutocompleteModel(id: number)
    {
        return (await axios.get<ListItemModel>(`${this.path}/autocomplete/${id}`)).data;
    }

    public static async getAutocompleteList(search: string, limit: number = 10)
    {
        return (await axios.get<ListItemModel[]>(`${this.path}/autocomplete`, {
            params: {
                search: search,
                limit: limit
            }
        })).data;
    }

    public static async getSelectedFromWidget(id: number)
    {
        return (await axios.get<ListItemModel[]>(`${this.path}/widget/${id}`)).data;
    }
}

export interface ListItemModel
{
    id: number;
    name: string;
    articlesQty?: number;
    dateCreatedUtc?: DateTime;
    dateModifiedUtc?: DateTime;
    position?: number;
}

export interface FormModel
{
    id: number;
    name: string;
}

export interface FilterModel
{
    name: string;
}

export interface PositionModel
{
    id: number;
    position: number;
}
